export class mergeDoInfoRequest{
  doNo?: string
  taskCode?: string
  taskValue: string | null
  createUser?: string
  updateUser?: string
  assignForwarder?: string | null

  constructor(){
    this.doNo = undefined
    this.taskCode = undefined
    this.taskValue = null
    this.createUser = undefined
    this.updateUser = undefined
    this.assignForwarder = undefined
  }
}
